import { render, staticRenderFns } from "./EditGroup.vue?vue&type=template&id=600d110c&scoped=true&"
import script from "./EditGroup.vue?vue&type=script&lang=ts&"
export * from "./EditGroup.vue?vue&type=script&lang=ts&"
import style0 from "./EditGroup.vue?vue&type=style&index=0&id=600d110c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600d110c",
  null
  
)

export default component.exports